
import {Form, Input, Select} from "antd";
import InputWrap from "../../InputWrap";
import {CustomButton} from "../../Button";
import React from "react";

const {Option} = Select;

const EditSiloGroupHeader = ({
    siloName,
    deviceCount,
    groupTypes,
    onSave,
    handleSelectGroupType,
    selectedGroupType,
    onSiloNameChange,
    form
}) => {
    return (
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', marginBottom: '30px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#444', marginBottom: '15px' }}>Group Settings</h2>

            <Form onFinish={onSave} layout="vertical" form={form}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>

                  <InputWrap title="Device Group Name*">
                        <Form.Item name="Device Group Name"
                                               initialValue={siloName}
                                               rules={[{
                                                   required: true,
                                                   message: "Please input your Device Group Name",
                                               }]}>
                                        <Input onChange={(e) => onSiloNameChange(e.target.value)}/>
                                    </Form.Item>


                    </InputWrap>
                      <InputWrap title="Type*">
                                    <Form.Item name="groupTypeID"
                                                initialValue={selectedGroupType}
                                               //initialValue={(groupTypes && groupTypes.length > 0) && groupTypes[0].title}
                                               rules={[{
                                                   required: true,
                                                   message: "Please select your silo type",
                                                }]}>
                                        <Select  onSelect={handleSelectGroupType}>
                                            {groupTypes && groupTypes.map((item: any) => (
                                                <Option value={item?.id}
                                                        key={item.name}
                                                >
                                                    {item?.name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </InputWrap>
                    <label style={{ color: '#555' }}>Number of Devices: {deviceCount}</label>
                    <Form.Item>
                        <CustomButton width="94px"
                                      height="40px"
                                      padding="2px 2px"
                                      fontSize="13px"
                                      className="mar-right-10"
                                      htmlType="submit"
                        >
                            <span>SAVE</span>
                        </CustomButton>
                    </Form.Item>
                </div>
            </Form>
        </div>
    );
};
export default EditSiloGroupHeader